export const generateBaseUrl = () => {
  const baseUrl =
    process.env.STAGE === 'dev'
      ? 'https://fa-dealer-search.cdn.dev.arcade.apps.one.audi/next/static/assets'
      : `https://fa-dealer-search.cdn.prod.arcade.apps.one.audi/${process.env.APP_VERSION}/static/assets`;

  return baseUrl;
};
